import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {PricesCityAnalyticsLocation} from "./prices_city_analytics";
import {PricesCitySectionName} from "./track_prices_city_view_section";

interface ITrackPricesCityRoomsFilterAppliedParams {
    /** Rooms option label exactly as the select shows it, including "Wszystkie". */
    rooms: string;
    sectionName: PricesCitySectionName;
    location: PricesCityAnalyticsLocation;
}

export const trackPricesCityRoomsFilterApplied = (params: ITrackPricesCityRoomsFilterAppliedParams) => {
    trackAmplitudeEvent("listing_filters_applied", {
        filter_trigger: "manual",
        location: params.location,
        section_name: params.sectionName,
        rooms: params.rooms
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {PricesCityAnalyticsLocation} from "./prices_city_analytics";
import {PricesCitySectionName} from "./track_prices_city_view_section";

interface ITrackPricesCityRoomsFilterAppliedParams {
    /** Rooms option label exactly as the select shows it, including "Wszystkie". */
    rooms: string;
    sectionName: PricesCitySectionName;
    location: PricesCityAnalyticsLocation;
}

export const trackPricesCityRoomsFilterApplied = (params: ITrackPricesCityRoomsFilterAppliedParams) => {
    trackAmplitudeEvent("listing_filters_applied", {
        filter_trigger: "manual",
        location: params.location,
        section_name: params.sectionName,
        rooms: params.rooms
    });
};
